import { Ref, ref, reactive, watch } from 'vue';
import { searchMedias, getMediaMetadataTally } from '@/services/data/media';
import { writeUrlRequest } from '@/config/common';

// type MediaTagType = {
//   documentMap: Record<string, string>
//   subjectMap: Record<string, string>
//   mainTypeMap: Record<string, string>
// };
// /* get Tag API return */
// type MediaTallyType = {
//   tags: MediaTagType,
//   year: Record<number, number>
// };
/* indiviudal API media object */
export type MediaItemType = {
  '@id'?: string;
  '@name'?: string;
  '@path': string;
  id: string;
  category?: string[];
  media?: string;
  subject?: string[];
  image?: string;
  imagePath?: string;
  // imageLink?: string; // old blog use path name
  title?: string;
  tags?: string[];
  pageDescription?: string;
  postDate?: string;
  postedBy?: string;
  isFeatured?: boolean;
}
// export type MediaItemType = typeof MediaItem;

/* API return object */
type MediaQueryResultType = {
  totalPage?: number,
  startPage?: number,
  recordPerPage?: number
  totalRecord?: number
  featured?: MediaItemType[],
  results?: MediaItemType[]
};
/* UI Stats */
type MediaStatsType = {
  subject?: Record<number, number>,
  // region: t.union([RegionTS, t.undefined]),
  category?: Record<number, number>,
  page?: {
    totalPage?: number,
    startPage?: number,
    recordPerPage?: number
    totalRecord?: number
  }
};

export type QueryParameterType = {
  rootPath?: string | null,
  // categoryId?: number | null,
  category?: string | null,
  // subjectId?: number | null,
  subject?: string | null,
  media?: string | null,
  // mediaId?: number | null,
  searchText?: string | null, // UI use this
  itemPerPage: number,
  tags?: string | null,
  postedBy?: string | null,
  year?: number | null,
  page: number | null, /* start Page */
  sortBy?: number | null, /* sorting order, by default newest to oldest */
};

export const FEATURED_POST_SIZE = 2;
export const numFeatured = 2;

const defaultRecordPerPage = 12;
const appState = reactive({
  inFilterTerm: '', /* this is for holding user input, before they click enter or search button, just to save api calls when users enter partial words */
  pageNumber: 1,
  recordPerPage: defaultRecordPerPage,
});

export const defaultQueryParam:QueryParameterType = {
  rootPath: '/abmi-home/connect/media-story-hub/',
  category: null,
  subject: null,
  searchText: null,
  itemPerPage: defaultRecordPerPage,
  page: 1, /* start Page */
  sortBy: 1, /* sorting order, by default newest to oldest */
};
export type tagOptionType = {
  category: string[];
  subject: string[];
  media: string[];
};
// export const tagOptions:tagOptionType = {
//   category: ['Blog Posts',
//     'Events',
//     'In the News',
//     'News',
//     'Videos'],
//   subject: [
//     'Climate Change',
//     'Contest',
//     'Data',
//     'Fieldwork',
//     'Geospatial',
//     'Habitat Monitoring',
//     'Human Footprint',
//     'Policy',
//     'Species Monitoring',
//     'Taxonomy',
//     'Webinar',
//   ],
//   media: [
//     'Blog Posts',
//     'Documents',
//     'Links',
//     'Videos',

//   ],
// };

export type requestKeys = keyof QueryParameterType;
type optionKeys = keyof tagOptionType;

/**
 * read query parameters from url passing request string
 * @returns query object
 */
function readRequest ():QueryParameterType {
  const requestParam:QueryParameterType = { ...defaultQueryParam };
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // Object.keys(tagOptions).forEach(key => getRequestParamByIdOrNameLocal(urlParams, requestParam, key as optionKeys));
  ['category', 'subject', 'media', 'tags', 'searchText', 'postedy'].forEach((key) => {
    requestParam[key as optionKeys] = urlParams.get(key) ?? null;
  });
  // requestParam.searchText = urlParams.get('searchText') ?? null;
  // requestParam.tags = urlParams.get('tags') ?? null;
  // requestParam.postedBy = urlParams.get('postedBy') ?? null;
  requestParam.page = +(urlParams.get('page') ?? 1);
  // requestParam.sortBy = +(urlParams.get('sortBy') ?? 1);
  if (urlParams.get('year') != null) {
    requestParam.year = parseInt(urlParams.get('year') ?? '0');
  }
  return requestParam;
}

export function useAppState () {
  return appState;
}

function app () {
  const state = useAppState();
  const mediaList: Ref<MediaItemType[]> = ref([]);
  const queryParam:Ref<QueryParameterType> = ref(readRequest()); /** clone from default */
  const mediaStats:Ref<MediaStatsType> = ref({});
  const isLoading: Ref<boolean> = ref(true);

  const tagOptions: Ref<Record<string, Record<string, number>>> = ref({});
  const yearOptions = ref();
  // Init loads anything needed at startup
  const init = async () => {
    tagOptions.value = await getMediaMetadataTally(defaultQueryParam);
    await query();
  };

  const clearAllFilter = () => {
    queryParam.value = { ...defaultQueryParam };
  };
  /* clear the whole query item, if it is array set it as empty, */
  const clearQueryItem = (fieldKey:requestKeys) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (queryParam.value[fieldKey] as any) = null;
  };
  const updatePage = (pageNumber:number) => {
    queryParam.value.page = Math.max(1, pageNumber);
  };

  watch(queryParam, () => {
    query();
  }, { deep: true });

  const query = async () => {
    isLoading.value = true;
    writeUrlRequest(queryParam.value, ['page', 'itemPerPage', 'sortBy', 'rootPath', 'category', 'subject', 'searchText']);
    const data = await searchMedias(queryParam.value) as MediaQueryResultType;
    mediaList.value = data.results ?? [];
    // mediaStats.value.category = data.category;
    // mediaStats.value.subject = data.subject;
    mediaStats.value.page = {
      startPage: queryParam.value?.page ?? 1,
      totalPage: data.totalPage,
      totalRecord: data.totalRecord ?? 0,
      recordPerPage: queryParam.value?.itemPerPage ?? 20,
    };
    isLoading.value = false;
  };

  init();
  return {
    state,
    tagOptions,
    yearOptions,
    queryParam,
    updatePage,
    clearQueryItem,
    clearAllFilter,
    query,
    mediaList,
    mediaStats,
    isLoading,
  };
}
const appSingleton = app();
export function mediaSearchState () {
  // NOTE: Any setup hooks must be called here.
  // This gets called from every setup() that uses the app.
  return appSingleton;
}
